export default {
  svgPath: `
    <path fill-rule="evenodd" clip-rule="evenodd" d="M11.5.833v10.92l2.876-2.877 1.414 1.414-5.26 5.26-5.706-5.23 1.351-1.474L9.5 11.893V.833h2zm-11.167 15V12.5h2v3.333a2.333 2.333 0 002.333 2.334h11.667a2.333 2.333 0 002.333-2.334V12.5h2v3.333a4.333 4.333 0 01-4.333 4.334H4.666a4.333 4.333 0 01-4.333-4.334z"/>
  `,
  title: 'Download',
  viewBox: '0 0 21 21',
};
